import { workspaceSelectionDeclarationsPath, workspaceSelectionInfoPath, workspaceSelectionReviewsPath, workspaceSelectionVotePath } from '../selectionWorkspacePaths';

export function buildSelectionWorkspaceMenuEntries(projectId, options = {}) {
    const { isCreateMode = false } = options;
    const items = [
        { key: workspaceSelectionInfoPath(projectId), label: '项目信息', icon: 'bi bi-info-circle' },
        { key: workspaceSelectionDeclarationsPath(projectId), label: '申报管理', icon: 'bi bi-folder2-open' },
        { key: workspaceSelectionVotePath(projectId), label: '投票管理', icon: 'bi bi-hand-thumbs-up' },
        { key: workspaceSelectionReviewsPath(projectId), label: '评议管理', icon: 'bi bi-clipboard-check' },
    ];

    if (!isCreateMode) {
        return items;
    }

    return items.map((item, index) => ({
        ...item,
        disabled: index !== 0,
    }));
}
